module.exports = __webpack_public_path__ + "static/img/incheon-investment.781f8cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/incheon-investment.jpg
// module id = cj7u
// module chunks = 0